import { render, staticRenderFns } from "./MessageCategory.vue?vue&type=template&id=5cfe2701&scoped=true&"
import script from "./MessageCategory.vue?vue&type=script&lang=js&"
export * from "./MessageCategory.vue?vue&type=script&lang=js&"
import style0 from "./MessageCategory.vue?vue&type=style&index=0&id=5cfe2701&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfe2701",
  null
  
)

export default component.exports